<template>
  <b-table
      class="OrdersTable"
      checkable
      :is-row-checkable="isRowCheckable"
      :checked-rows.sync="checkedRows"
      hoverable
      paginated
      backend-pagination
      :data="orders"
      :columns="columns"
      :loading="isLoading"
      :empty="!isLoading && total === 0"
      :total="total"
      :per-page="perPage"
      backend-sorting
      default-sort-direction="desc"
      :default-sort="[sortParams.field, sortParams.order]"
      @page-change="changePage"
      @sort="changeSortParams"
      @update:checkedRows="$emit('update:checkedRows', $event)"
      @check="selectPermanentPoint"
  >
    <template slot-scope="props">
      <b-table-column field="id" :label="getLabel('id')">{{ props.row.id }}</b-table-column>

      <b-table-column field="name" :label="getLabel('name')">
        <a href @click.prevent="editPermanentPoint(props.row)">
          <span>{{ props.row.name }}</span>
        </a>
      </b-table-column>

      <b-table-column field="address" :label="getLabel('address')">
				<span v-if="props.row.lat && props.row.lon" class="address-marker">
					<i class="mdi">location_on</i>
				</span>
        <span v-html="getTableOrderAddress(props.row)"></span>
      </b-table-column>

      <b-table-column
          field="phone"
          :label="getLabel('phone')"
          class="nowrap"
          :visible=true
      >
        {{ props.row.phone }}
        <div v-if="props.row.scndPhone">{{ props.row.scndPhone }}</div>
      </b-table-column>


      <b-table-column
          field="createdDate"
          :label="getLabel('createdDate')"
          :visible="canSortByCreatedDate"
      >
        <div v-if="props.row.createdDate">
          {{ props.row.createdDate | humanDate }}
          <small>{{ props.row.createdDate | date('DD/MM/YYYY') }}</small>
        </div>
        <span v-else>-</span>
      </b-table-column>
    </template>

    <template slot-scope="props" slot="header">
      {{ props.column.label }}
      <i
          v-show="sortParams.field === props.column.field"
          :class="{ mdi: true, 'is-desc': sortParams.order === 'desc' }"
      >arrow_upward</i
      >
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Brak zamówień.</p>
        </div>
      </section>
    </template>
    <!-- <template slot="bottom-left" v-if="orders.length">
      <b>Wybranych</b>: {{ checkedRows.length }}
    </template>-->
    <template slot="bottom-left">
      <div class="per-page">
        <span>Pokaż rekordów:</span>
        <b-select @input="changePerPage($event)" :value="perPage">
          <option
              v-for="(value, index) in perPageOptions"
              :key="index"
              :value="value"
              :selected="value === perPage"
          >
            {{ value }}
          </option>
        </b-select>
      </div>
    </template>
  </b-table>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import config from '@/config'
import bus from '@/EventBus'
import { getColorByName, normalizeApiMontageDate } from '@/helpers'
import OrderService from '@/services/OrderService'
import PermanentPointService from "../../services/PermanentPointService";

export default {
  data() {
    return {
      orders: [],
      checkedRows: [],
      perPage: localStorage.getItem('orders-table-per-page') || 10,
      perPageOptions: config.company.perPageOptions,
      pageNr: 1,
      sortParams: {
        field: 'id',
        order: 'desc'
      },
      total: 0,
      isLoading: false,
      filter: {}
    }
  },
  computed: {
    columns() {
      return [
        {
          field: 'id',
          label: 'NR',
          sortable: true
        },
        {
          field: 'name',
          label: 'Nazwa',
          sortable: true
        },
        {
          field: 'address',
          label: 'Adres'
        },
        {
          field: 'phone',
          label: 'Telefon',
          visible: true
        },
        {
          field: 'createdDate',
          label: 'Dodano',
          sortable: true,
          visible: this.canSortByCreatedDate
        }
      ]
    },
    canSortByCreatedDate() {
      return config.company.canSortByCreatedDate
    }
  },
  methods: {
    getColorByName(hex) {
      return getColorByName(hex)
    },
    changePage(pageNr) {
      this.pageNr = pageNr
      this.loadOrders()
    },
    changePerPage(num) {
      this.perPage = num
      localStorage.setItem('orders-table-per-page', this.perPage)
      this.loadOrders()
    },
    changeSortParams(field, order) {
      this.sortParams = { field, order }
      this.loadOrders()
    },
    getTableOrderAddress(order) {
      let main = ''
      let aside = ''

      main += order.postalCode ? order.postalCode : ''
      if (order.city) main += ' ' + order.city
      else if (order.post) main += ' ' + order.post

      aside += order.street ? '(' + order.street + ')' : ''

      return main + '<br><small>' + aside + '</small>'
    },

    isRowCheckable(order) {
      return order && order.lat && order.lon
    },
    loadOrders() {
      this.isLoading = true

      const whereParams = []
      // if (this.filter.by === 'status' && this.filter.value === 'pending')
      // 	whereParams.push({
      // 		whereField: 'montageDate',
      // 		whereCondition: 'after',
      // 		whereValue: moment()
      // 			.add(14, 'days')
      // 			.format('YYYY-MM-DD')
      // 	})

      // if (this.filter.by === 'status' && this.filter.value === 'new') {
      // 	whereParams.push({
      // 		whereField: 'montageDate',
      // 		whereCondition: 'strictly_before',
      // 		whereValue: moment()
      // 			.add(14, 'days')
      // 			.format('YYYY-MM-DD')
      // 	})
      // }

      if (this.filterCountry) {
        whereParams.push({
          whereField: 'country',
          whereCondition: 'equal',
          whereValue: this.filterCountry
        })
      }

      const params = {
        sorting: this.sortParams,
        perPage: this.perPage,
        pageNr: this.pageNr,
        searchText: this.searchText,
        where: whereParams
      }

      PermanentPointService.getAll(params)
          .then((res) => this.loadOrdersSuccess(res.data))
    },
    loadOrdersSuccess(data) {
      this.orders = []
      this.total = data['totalItems'] || data['hydra:totalItems'] || 0
      if (this.total / this.perPage > 1000) {
        this.total = this.perPage * 1000
      }

      this.isLoading = false
      if (this.total === 0) return false
      const members = data['member'] || data['hydra:member'] || []
      members.forEach((item) => {
        this.orders.push(item)
      })
      this.checkedRows = []
    },

    getLabel(columnId) {
      return this.columns.filter(({ field }) => field === columnId)[0].label
    },

    selectPermanentPoint(point) {
      bus.$emit('permanent-point-select', point[0])
    },
    editPermanentPoint(point) {
      this.$emit('permanent-point-click', point)
    },
  },
  filters: {
    date(value, format) {
      return moment(value).format(format)
    },
    humanDate(value) {
      return moment(value).fromNow()
    }
  },
  created() {
    moment.locale('pl')

    this.loadOrders();

    this.events = [
      //'permanenet-point-search',
      'permanenet-point-refresh'
    ]
    bus.$on(this.events, () => {
      this.loadOrders()
    })
  },

}
</script>

<style lang="scss" scoped>
.is-small .mdi {
  font-size: 20px;
}
.address-marker .mdi {
  font-size: 20px;
  vertical-align: middle;
}
td.nowrap {
  white-space: nowrap;
}
[data-label='Dodano'] {
  small {
    display: block;
    font-size: 11px;
    color: #aaa;
  }
}
.route-link {
  & > * {
    vertical-align: middle;
  }
}
.route-color-preview {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin: 5px 5px 0;
  border: 1px solid #ccc;
  border-radius: 3px;
}
.per-page {
  > span {
    margin-right: 10px;
    vertical-align: middle;
    opacity: 0.5;
  }
  > div {
    display: inline-block;
    vertical-align: middle;
  }
}
.warning-icon {
  vertical-align: middle;
  padding-right: 5px;
  animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    color: red;
  }
}
</style>